import { api } from './api';

interface PresignedUrlResponse {
  uploadUrl: string;
  imageUrl: string;
  key: string;
}

export const uploadService = {
  /**
   * Get a presigned URL for uploading an image
   */
  getPresignedUrl: (filename: string, contentType: string) =>
    api.post<PresignedUrlResponse>('/uploads/presigned-url', { filename, contentType }),

  /**
   * Upload a file directly to S3 using a presigned URL
   */
  uploadToS3: async (presignedUrl: string, file: File): Promise<void> => {
    const response = await fetch(presignedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to upload image');
    }
  },

  /**
   * Complete flow: get presigned URL and upload file
   * Returns the permanent S3 URL for the uploaded image
   */
  uploadImage: async (file: File): Promise<string> => {
    // Get presigned URL from backend
    const { uploadUrl, imageUrl } = await uploadService.getPresignedUrl(file.name, file.type);

    // Upload directly to S3
    await uploadService.uploadToS3(uploadUrl, file);

    return imageUrl;
  },

  /**
   * Delete an image from S3
   */
  deleteImage: (imageUrl: string) => api.delete<void>('/uploads/image', { imageUrl }),
};
